import Navbar from "./Navigation/Nav";
import Section1 from "./Section1/Section1";

const Main = () => {
  return (
    <>
      <Navbar />
      <Section1 />
    </>
  );
};

export default Main;
